module.exports = __webpack_public_path__ + "static/media/comment-alt-smile.410df296.svg";